import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { formatSentenceCase } from "@redotech/util/string";

export const DeliveryStatusCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Delivery status",
    cell: (row) =>
      row.shipment?.tracker?.status
        ? formatSentenceCase(row.shipment?.tracker?.status)
        : "",
  };
